declare global {
  interface Window {
    __CLINIC_ONBOARDING_CONFIG__?: Record<string, string | undefined>;
  }
}

export function readRuntimeConfigValue(key: string) {
  if (typeof window === "undefined") {
    return "";
  }

  return window.__CLINIC_ONBOARDING_CONFIG__?.[key] || "";
}

export {};
